var map = {
	"./HelveticaNeueCyr-Black.woff": 256,
	"./HelveticaNeueCyr-Bold.woff": 257,
	"./HelveticaNeueCyr-ExtraBold.woff": 258,
	"./HelveticaNeueCyr-Light.woff": 259,
	"./HelveticaNeueCyr-Medium.woff": 260,
	"./HelveticaNeueCyr-Regular.woff": 261,
	"./HelveticaNeueCyr-Thin.woff": 262,
	"./HelveticaNeueCyr-UltraLight.woff": 263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;